﻿import {translation} from "@2d-front-monorepo/core";
import {Button, ErrorMessage, RemoteDataStatus, showErrorDialog, toggleLoadingDialog, useRemoteData} from "@2d-front-monorepo/design-library";
import {ParkingFeeDisplay, ParkingFeeDisplayType, PermitId, Permits} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate, useParams} from "react-router";
import InvalidPermitId from "../../components/InvalidPermitId";
import MaterialIcon from "../../components/MaterialIcon";
import {PermitsBackButton} from "../../components/PermitsBackButton";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import {getHttpClient} from "../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";
import PermitDates from "./ViewComponents/PermitDates";
import PermitTariffZone from "./ViewComponents/PermitTariffZoneResidencyVehicles";

export default function UnparkPermit(): JSX.Element {
	const {permitId} = useParams<{ permitId: string }>() as { permitId: PermitId };
	const navigate = useNavigate();
	const permitsState = usePermits();
	const permit = Permits.find(permitsState, permitId);

	const {data, status, error} = useRemoteData(() => getHttpClient().permits.queryUnpark(permitId), [permitId]);

	const confirm = useCallback(async function () {
		if (permit == null || data == null || data.length === 0) {
			return;
		}

		try {
			toggleLoadingDialog(true);
			const httpClient = getHttpClient();
			await httpClient.permits.confirmUnpark(permit.id, data[0].refunded.amount);
			await reloadPermits(ReloadEntities.Permits);
			navigate(PrivateRoutes.permitsList);
		} catch (e) {
			showErrorDialog(e)
		} finally {
			toggleLoadingDialog(false);
		}
	}, [permit?.id, data]);

	if (permit == null) {
		return <InvalidPermitId permitId={permitId}/>;
	}

	if (status === RemoteDataStatus.Loading) {
		return <PermitsInlineLoading/>;
	}

	if (status === RemoteDataStatus.Error) {
		return <ErrorMessage error={error}/>;
	}

	return (
		<>
			<h1>{translation(PermitTranslations.permit_unpark_page__title)}</h1>
			<hr/>
			<div className={"layout vertical gap"}>
				{data.map(function (value, index) {
					return (
						<section className="card" key={index}>
							<header><PermitDates permit={permit} startDate={value.newStartDate} endDate={value.newEndDate}/></header>
							<hr className="no-margin"/>
							<PermitTariffZone permit={permit}/>

							<h5 className="unparking-fee-display--title">{translation(PermitTranslations.permit_unpark_page__refunded)}</h5>
							<hr className="no-margin"/>
							<ParkingFeeDisplay price={value.refunded} layout={value.layout} autoHide={false} type={ParkingFeeDisplayType.Unparking}/>
						</section>
					);
				})}

				<div className="form__buttons form__buttons--bottom">
					<Button kind="primary" onClick={confirm}>
						<span>{translation(PermitTranslations.permit_unpark_page__button)}</span>
						<MaterialIcon icon="check"/>
					</Button>
					<span></span>
					<PermitsBackButton/>
				</div>
			</div>
		</>
	);
}
